// extracted by mini-css-extract-plugin
export default {"backContainer":"BackChevron_backContainer__vhpPJ","backIcon":"BackChevron_backIcon__meY9z"};